import { alpha } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useTreeMenuStyles = makeStyles(({ shape, palette, spacing }) =>
  createStyles({
    itemContent: {
      borderRadius: shape.borderRadius,
      display: 'flex',
      height: 'max-content',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: alpha(palette.common.black, 0.1),
      },
    },
    disabledItemContent: {
      pointerEvents: 'none',
    },
    labelWrapper: {
      flex: '1',
    },
    selected: {
      '& > $itemContent': {
        backgroundColor: alpha(palette.common.black, 0.05),
        '&:hover': {
          backgroundColor: alpha(palette.common.black, 0.1),
        },
      },
    },
    highlighted: {
      '& > $itemContent': {
        backgroundColor: alpha(palette.primary.main, 0.3),

        '&:hover': {
          backgroundColor: alpha(palette.primary.main, 0.5),
        },
      },
    },
    expandIcon: {
      transition: 'transform .25s ease-out',
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
    itemLabel: {
      // we want to disable the default selection background color on the label, and use the content wrapper
      backgroundColor: 'transparent !important',
      textTransform: 'capitalize',
    },
    link: {
      display: 'block',
      color: palette.text.primary,
      textDecoration: 'none',
      paddingTop: spacing(),
      paddingBottom: spacing(),
    },
    chipRoot: {
      flex: 1,
      borderRadius: shape.borderRadius,
      width: '100%',
      justifyContent: 'flex-start',
    },
    itemWrapper: {
      paddingTop: spacing(),
      paddingBottom: spacing(),
      cursor: 'pointer',
    },
  })
);

export default useTreeMenuStyles;
